import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrowup",
  "use": "icon-arrowup-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrowup\">\r\n<g clip-path=\"url(#icon-arrowup_clip0_4209_120776)\">\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.4714 10.4714C8.21107 10.7318 7.78893 10.7318 7.5286 10.4714L3.75736 6.70017C3.49701 6.43985 3.49701 6.01775 3.75736 5.75739C4.01771 5.49705 4.43982 5.49705 4.70017 5.75739L8 9.05724L11.2998 5.75739C11.5602 5.49705 11.9823 5.49705 12.2427 5.75739C12.503 6.01775 12.503 6.43985 12.2427 6.70017L8.4714 10.4714Z\" fill=\"#999999\" />\r\n</g>\r\n<defs>\r\n<clipPath id=\"icon-arrowup_clip0_4209_120776\">\r\n<rect width=\"16\" height=\"16\" fill=\"white\" />\r\n</clipPath>\r\n</defs>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/arrowup.svg
// module id = /FqL
// module chunks = 3